import BgSvg from "@/assets/svg/task/cta.svg";
import { ArrowRight, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import Button from "../ui/button";

export default function CTA() {
  return (
    <div className="h-[450px] flex flex-col items-center justify-center relative overflow-hidden px-8 4xl:max-w-[100rem] 4xl:mx-auto">
      <img
        src={BgSvg}
        className="absolute top-1/2 -translate-y-1/2 z-0 w-full pointer-events-none opacity-10"
        alt="Image"
      />
      <div className="w-full  flex flex-col items-center justify-center gap-12 !z-0">
        <h1 className="text-primaryLight text-3xl md:text-4xl max-w-3xl text-center">
          Not sure which model fits your needs? Let us help you find the perfect
          match.
        </h1>
        <div className="flex flex-col md:flex-row items-center gap-4">
          <Link to="/contact-us">
            <Button className="group relative rounded-full shadow bg-white text-primary py-6 w-48 flex items-center justify-center gap-2 overflow-hidden hover:text-white hover:bg-primary z-50">
              <span className="transform transition-transform duration-300 group-hover:translate-x-5">
                Send us a message
              </span>
              <Mail className="transform transition-transform duration-300 group-hover:-translate-x-[130px]" />
            </Button>
          </Link>
          <Link to="/hire-a-talent">
            <Button className="group relative rounded-full shadow bg-primary text-white py-6 flex w-48 items-center justify-center gap-2 overflow-hidden hover:text-primary hover:bg-white z-50">
              <span className="transform transition-transform duration-300 group-hover:translate-x-5">
                Hire a talent
              </span>
              <ArrowRight className="transform transition-transform duration-300 group-hover:-translate-x-[90px]" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
